import { createStore, applyMiddleware, compose, StoreEnhancer } from 'redux';
import rootReducer from './reducers/index';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import persistState from 'redux-localstorage';
import { User, Appointment, Patient, Laboratory } from '../models';

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const RE_ISO_DATE =
  /\d{4}-[01]\d-[0-3]\dT?[0-2]\d:[0-5]\d(?::[0-5]\d(?:.\d{1,6})?)?(?:([+-])([0-2]\d):?([0-5]\d)|Z)/;

let persistStateConfig = {
  deserialize: (serializedData: string) => {
    return JSON.parse(serializedData, function (k, v) {
      // TODO: check https://stackoverflow.com/questions/56189690/typescript-check-if-object-matches-type
      if (typeof v === 'string' && v.match(RE_ISO_DATE)) {
        return new Date(v);
      } else if (k === 'user' && v !== null) {
        return new User(v);
      } else if (k === 'users' && Array.isArray(v)) {
        return v.map((item: any) => new User(item));
      } else if (k === 'appointment') {
        return new Appointment(v);
      } else if (k === 'appointments' && Array.isArray(v)) {
        return v.map((item: any) => new Appointment(item));
      } else if (k === 'patients' && Array.isArray(v)) {
        return v.map((item: any) => new Patient(item));
      } else if (k === 'patient') {
        return new Patient(v);
      } else if (k === 'laboratory') {
        return new Laboratory(v);
      } else if (k === 'laboratories' && Array.isArray(v)) {
        return v.map((item: any) => new Laboratory(item));
      } else if (k === 'document' && Object.entries(v).length === 0) {
        return;
      }
      return v;
    });
  }
};

const enhancer: StoreEnhancer = composeEnhancers(
  applyMiddleware(thunk),
  persistState(undefined, persistStateConfig)
);

export const configureStore = (preloadedState: any) =>
  createStore(rootReducer, preloadedState, enhancer);

export default configureStore({});
